export enum CertificateStatus {
    pending = 1,
    approved = 2,
    rejected = 3,
    expired = 4,
    revoked = 5
}

const CERTIFICATE_STATUS_TRANSLATION_KEYS: Record<CertificateStatus, string> = {
    [CertificateStatus.pending]: 'review_pending',
    [CertificateStatus.approved]: 'in_force',
    [CertificateStatus.rejected]: 'rejected',
    [CertificateStatus.expired]: 'expired1',
    [CertificateStatus.revoked]: 'revoked'
};

const CERTIFICATE_STATUS_COLOR: Record<CertificateStatus, string> = {
    [CertificateStatus.pending]: 'warning',
    [CertificateStatus.approved]: 'success',
    [CertificateStatus.rejected]: 'error',
    [CertificateStatus.expired]: 'error',
    [CertificateStatus.revoked]: 'error'
};

export interface CertificateStatusResubmitAlert {
    type: 'error' | 'info';
    messageKey: string;
    showReason: boolean;
}

const CERTIFICATE_STATUS_RESUBMIT_ALERT: Record<CertificateStatus, CertificateStatusResubmitAlert | null> = {
    [CertificateStatus.pending]: null,
    [CertificateStatus.approved]: null,
    [CertificateStatus.rejected]: { type: 'error', messageKey: 'certificate_has_been_rejected', showReason: true },
    [CertificateStatus.expired]: { type: 'info', messageKey: 'certificate_has_expired', showReason: false },
    [CertificateStatus.revoked]: { type: 'error', messageKey: 'certificate_has_been_revoked', showReason: true }
};

export function getCertificateStatusResubmitAlert(status: CertificateStatus): CertificateStatusResubmitAlert | null {
    return CERTIFICATE_STATUS_RESUBMIT_ALERT[status] ?? null;
}

export function getCertificateStatusText(status: CertificateStatus): string {
    return CERTIFICATE_STATUS_TRANSLATION_KEYS[status] ?? '';
}

export function getCertificateStatusColor(status: CertificateStatus): string {
    return CERTIFICATE_STATUS_COLOR[status] ?? 'default';
}
